/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ReCAPTCHA from "react-google-recaptcha";

import {colors} from "nxtconstants";
import {WealthyEnv} from "helpers";

import {
  wrapper,
  title,
  button,
  error,
  infoline
} from "../styledElements";

const userIcon = `${WealthyEnv.BROKING_CDN_URL}/username-icon.png`;
const mobileIcon = `${WealthyEnv.BROKING_CDN_URL}/mobile-icon.png`;

const propTypes = {
  handleCredentials: PropTypes.func,
  handleInput: PropTypes.func,
  handleRecaptchaToken: PropTypes.func,
  resetPin: PropTypes.bool,
  autoFocus: PropTypes.bool
};

const UserCredentials = ({
  handleInput,
  handleCredentials,
  handleRecaptchaToken,
  resetPin,
  autoFocus = false
  // recaptchaRef
}) => {
  const resetCaptcha = () => {
    recaptchaRef.current?.reset();
  };

  return (
    <UserCredentialsWrapper>
      <Title>
        {resetPin ? "Welcome Back!" : "Welcome to Wealthy"}
      </Title>
      {
        resetPin && (
          <InfoLine>Login to setup new pin.</InfoLine>
        )
      }
      <FieldsWrapper>
        <FormGroup>
          <InputWrapper>
            <InputField
              autoFocus={autoFocus}
              placeholder="Full Name"
              type="text"
              onKeyUp={(e) => handleInput(e, "name")}
            />
            <Icon
              alt="user"
              src={userIcon}
            />
          </InputWrapper>
        </FormGroup>
        <FormGroup>
          <InputWrapper className="country-code">
            <InputField
              maxLength="10"
              placeholder="Mobile Number"
              type="text"
              onKeyUp={(e) => handleInput(e, "phone_number")}
            />
            <Icon
              alt="mobile"
              src={mobileIcon}
            />
          </InputWrapper>
        </FormGroup>
        {/* <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={WealthyEnv.FURY_RECAPTCHA_SITE_KEY}
          size="invisible"
          onChange={() => {}, () => resetCaptcha()}
        /> */}
        <CaptchaWrapper>
          <ReCAPTCHA
            sitekey={WealthyEnv.FURY_RECAPTCHA_SITE_KEY}
            onChange={handleRecaptchaToken}
          />
        </CaptchaWrapper>
      </FieldsWrapper>
      <SubmitCredentials onClick={() => handleCredentials()}>
        Submit
      </SubmitCredentials>
    </UserCredentialsWrapper>
  );
};

const UserCredentialsWrapper = styled(wrapper)``;

const Title = styled(title)``;

const InfoLine = styled(infoline)`
  padding: 0;
`;

const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  padding-top: 4.4rem;
  width: 280px;

  @media (max-width: 768px) {
    padding-top: 2.4rem;
  }
`;

const FormGroup = styled.div``;

const InputWrapper = styled.div`
  border-radius: 6px;
  border: 1px solid #DDD;
  display: flex;
  align-items: center;
  overflow: hidden;

  &.country-code {
    position: relative;

    input {
      padding-left: 5rem;
    }

    &::before {
      content: "+91";
      position: absolute;
      top: 0;
      left: 0;
      font-size: 1.6rem;
      background-color: #efefef;
      color: ${colors.textGray};
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    }
  }

  @media (max-width: 576px) {
    width: 100%;
  }
`;

const Icon = styled.img`
  flex-shrink: 0;
  height: 24px;
  padding-right: 1rem;
`;

const InputField = styled.input`
  flex: 1;
  outline: 0;
  border: 0;
  padding: 1.4rem 1.4rem;
  font-size: 1.6rem;
  color: ${colors.black};

  &::placeholder {
    font-size: 1.6rem;
    color: ${colors.textGray};
  }
`;

const CaptchaWrapper = styled.div`
  scale: 0.9;
  transform: translateX(-10px);
`;

const SubmitCredentials = styled(button)`
  width: 100%;
  margin: 3rem 0 4.4rem;

  @media (max-width: 768px) {
    margin-bottom: 0;
  }
`;

UserCredentials.propTypes = propTypes;

export default UserCredentials;
